import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { brainReturnHref } from "@/lib/brain/deck";

/**
 * "Back to colivIQ" — shown on any admin screen opened from a Brain card
 * (`?from=brain&item=<id>`), returning to that same card.
 */
export function BrainReturnStrip() {
  const { t } = useLanguage();
  const href = brainReturnHref(new URLSearchParams(useLocation().search));
  if (!href) return null;
  return (
    <div className="border-b bg-muted/60">
      {/* Same gutter as the nav strip above, so the link lines up with it. */}
      <div className="mx-auto flex w-full max-w-[1920px] items-center px-4 py-1.5 text-sm sm:px-6 lg:px-8">
        <Link
          to={href}
          className="inline-flex items-center gap-1.5 font-medium hover:underline"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
          {t("brain.return.back", "Back to colivIQ")}
        </Link>
      </div>
    </div>
  );
}
